import React from 'react'
import LinePlaneFlyIcon from 'LuxKit/Icons/line/LinePlaneFlyIcon'
import { getDefaultAirportCode } from 'selectors/flightsSelectors'
import { connect } from 'react-redux'
import { getBundledWithFlightOfferDisplayPricing } from 'lib/offer/getOfferDisplayPricing'
import Group from 'components/utils/Group'
import PriceRowFlightPackage from 'LuxKit/PricePoints/PriceRowFlightPackage'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'

interface Props {
  airportCode: string
  bundledWithFlightsOnly: boolean
  flightPrices: { [airportCode: string]: number }
  price: number
  memberPrice: number
  value?: number
  duration: string
  offer?: App.AnyOffer
}

function BundledHotelPriceContent({
  airportCode,
  bundledWithFlightsOnly,
  flightPrices,
  price,
  memberPrice,
  value,
  duration,
  offer,
}: Props) {
  const flightPrice = flightPrices[airportCode]

  const result = getBundledWithFlightOfferDisplayPricing(bundledWithFlightsOnly, flightPrice, price, memberPrice, value ?? price)

  if (result.isBundledFlightPriceDisplayable) {
    const { packagedTotal, packagedMemberTotal, flightPrice } = result
    return (
      <Group direction="vertical" gap={4}>
        <PriceRowPriceCaption startIcon={<LinePlaneFlyIcon />}>
          {duration}{flightPrice && ' + flights from'}
        </PriceRowPriceCaption>
        <LuxPlusPriceStack
          size="S"
          price={Math.ceil(packagedTotal!)}
          saleUnit="total*"
          memberPrice={Math.ceil(packagedMemberTotal!)}
          offerConfig={offer?.luxPlus}
        />
      </Group>

    )
  }

  return <PriceRowFlightPackage price={undefined} product="hotel" />
}

function mapStateToProps(state: App.State) {
  return {
    airportCode: getDefaultAirportCode(state),
  }
}

export default connect(mapStateToProps)(BundledHotelPriceContent)
